import { createContext } from 'react';

/** Identifies whether the enclosing card form is creating or editing a record. */
export type CardFormType = 'CREATE' | 'EDIT';

/**
 * Provides the current card form operation type to descendant components.
 * Set to 'CREATE' in CardEntityCreateForm and 'EDIT' in CardEntityEditForm.
 * Defaults to 'EDIT' so legacy paths (SubformViewContainer) behave correctly
 * without an explicit provider.
 */
export const CardFormTypeContext = createContext<CardFormType>('EDIT');
